import React, { useState } from "react";
import "./index.scss";
import * as _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Tabs = ({ config, children }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = _.get(config, "tabs", []);
  const actions = _.get(config, "actions", []);
  const isPath = _.get(config, "isPath", false);
  const onChangeTab = _.get(config, "onChangeTab");

  const tabsArray = children ? React.Children.toArray(children) : [];

  return (
    <div>
      <div className={isPath ? "div-tab-path" : "div-tab"}>
        <div style={{ display: "flex", flex: 1 }}>
          {isPath
            ? tabs.map((tab) => (
                <button
                  key={tab.path}
                  onClick={() => {
                    navigate(tab.path);
                    if (onChangeTab) {
                      onChangeTab(tab);
                    }
                  }}
                  className={
                    location.pathname === tab.path
                      ? "tab-button-path-active "
                      : "tab-button-path"
                  }
                >
                  {t(tab.label)}
                </button>
              ))
            : tabsArray.map((child, index) => (
                <button
                  key={index}
                  onClick={() => {
                    setActiveTab(index);
                    if (onChangeTab) {
                      onChangeTab(child.props);
                    }
                  }}
                  className={
                    activeTab === index ? "tab-button-active" : "tab-button"
                  }
                >
                  {t(child.props.label)}
                </button>
              ))}
        </div>
        {actions.map((action) => (
          <div className="div-tab-action">
            <span className="color-gray">|</span>
            {action}
          </div>
        ))}
      </div>
      {!isPath && (
        <div>
          <br />
          {tabsArray[activeTab]}
        </div>
      )}
    </div>
  );
};

export default Tabs;
